import React from 'react';
import { Field, FieldAttributes } from 'formik';

export const InputField = (props: FieldAttributes<any>) => {
  return <Field {...props} />;
};
